import LayoutUtils from 'src/utils/layout_utils';

/**
 * Creates the submit button state updater for the time section (Save vs Schedule, submit info text).
 * Returns updateSubmitInfo() that should be called when selection or lockbox value changes.
 */
export function createSubmitStateUpdater(form, section, elements, originalValues) {
  const {
    submitText,
    submitInfo,
    showtimeTypeSelect,
    selectedInput,
    lockboxShowtimeInput,
    lockboxDateSelect,
    lockboxTimeSelect,
    customDateInput,
    customTimeInput,
    customDurationInput
  } = elements;
  const {
    originalShowtimeValue,
    originalLockboxShowtimeValue,
    originalCustomDateValue,
    originalCustomTimeValue,
    originalCustomDurationValue
  } = originalValues;

  const setSubmitState = (changed, scheduleText = '') => {
    if (submitText) {
      submitText.textContent = changed ? 'Schedule' : 'Save Showing';
    }
    if (!submitInfo) return;
    if (!changed) {
      submitInfo.textContent = '';
      LayoutUtils.hide(submitInfo);
      return;
    }
    submitInfo.textContent = scheduleText;
    LayoutUtils.toggle(submitInfo, scheduleText.trim() !== '');
  };

  return function updateSubmitInfo() {
    const customMode = showtimeTypeSelect?.value === 'custom';
    const lockboxMode = showtimeTypeSelect?.value === 'lockbox';
    if (customMode) {
      const dateText = customDateInput?.value?.trim() || '';
      const timeText = customTimeInput?.value?.trim() || '';
      const durationText = customDurationInput?.value?.trim() || '';
      const changed = (
        dateText !== originalCustomDateValue ||
        timeText !== originalCustomTimeValue ||
        durationText !== originalCustomDurationValue
      );
      setSubmitState(changed, `${dateText} ${timeText}`.trim());
      return;
    }

    if (lockboxMode) {
      const lockboxValue = lockboxShowtimeInput?.value || '';
      const changed = lockboxValue !== '' && lockboxValue !== originalLockboxShowtimeValue;
      if (!changed) {
        setSubmitState(false);
        return;
      }
      if (lockboxValue === 'NOW') {
        setSubmitState(true, 'Now');
      } else {
        const dateText = lockboxDateSelect?.selectedOptions?.[0]?.text || '';
        const timeText = lockboxTimeSelect?.value || '';
        setSubmitState(true, `${dateText} ${timeText}`.trim());
      }
      return;
    }

    const selectedValue = selectedInput?.value || '';
    const changed = selectedValue !== '' && selectedValue !== originalShowtimeValue;
    if (!changed) {
      setSubmitState(false);
      return;
    }
    const selectedSlot = section.querySelector('.js-showing-view-time-slot--selected');
    setSubmitState(true, selectedSlot?.dataset?.shortLabel || '');
  };
}
